// react and js
import { React, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Grid, Container } from "@mui/material";

// components
import Page from "../../components/Page";

// hooks

// layouts

// pages

// theme

// utils

// widgets
import WidgetInvoicesAndReceipes from "../../widgets/accounting/InvoicesAndReceipes";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Accounting() {
  const { t } = useTranslation();

  // ######################################################
  // Scroll to top on mount
  // ######################################################
  useEffect(() => {
    const autoScrollContainer = document.querySelector(
      "#auto-scroll-container"
    );
    if (autoScrollContainer !== null) {
      autoScrollContainer.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ######################################################
  // Main outlet
  // ######################################################

  // eslint-disable-next-line
  return useMemo(() => {
    return (
      <Page title={t("pages.accounting.title")}>
        <Container maxWidth="false">
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <WidgetInvoicesAndReceipes />
            </Grid>
          </Grid>
        </Container>
      </Page>
    );
  }, [t]);
}
